import React from "react";
import { Box, Paper, Skeleton, Typography } from "@mui/material";
import { formatearFecha, formatearMonto } from "../../../../helpers/formato";
import { DatoResumen, antiguedadDesde } from "../comunes";

// Respeta "reducir movimiento": el esqueleto queda quieto.
const sinAnimacion = {
  "@media (prefers-reduced-motion: reduce)": { animation: "none" },
};

/**
 * Resumen del empleado bajo el encabezado, con lo que ya se cargó (sin pedir nada nuevo):
 * salario básico, fecha de ingreso y antigüedad.
 *
 * @param {object} props
 * @param {{salario: number, fechaInicioContrato: string, isActive: boolean}|null} props.empleado
 *   Null mientras no han llegado los datos.
 * @param {boolean} [props.fallo] No se pudieron cargar: se deja de esperar y se muestra "—".
 */
const ResumenEmpleado = ({ empleado, fallo = false }) => {
  const cargando = !empleado && !fallo;

  const valor = (texto) =>
    cargando ? (
      <Skeleton variant="text" width={110} sx={{ fontSize: "1.25rem", ...sinAnimacion }} />
    ) : (
      <Typography
        component="span"
        variant="monto"
        sx={{ overflowWrap: "anywhere" }}
      >
        {texto}
      </Typography>
    );

  // Para un empleado inactivo no se sabe hasta cuándo trabajó: la antigüedad solo se calcula en los activos.
  const antiguedad =
    empleado && empleado.isActive ? antiguedadDesde(empleado.fechaInicioContrato) : null;

  return (
    <Paper
      component="section"
      aria-label="Resumen del empleado"
      aria-busy={cargando || undefined}
      sx={{ p: { xs: 2, sm: 3 }, mb: 2 }}
    >
      <Box
        component="dl"
        sx={{
          m: 0,
          display: "grid",
          gap: 2,
          gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", md: "repeat(3, minmax(0, 1fr))" },
        }}
      >
        <DatoResumen etiqueta="Salario básico">
          {valor(empleado ? formatearMonto(empleado.salario) : "—")}
        </DatoResumen>
        <DatoResumen etiqueta="Fecha de ingreso">
          {valor(empleado ? formatearFecha(empleado.fechaInicioContrato) : "—")}
        </DatoResumen>
        <DatoResumen etiqueta="Antigüedad">{valor(antiguedad || "—")}</DatoResumen>
      </Box>
    </Paper>
  );
};

export default ResumenEmpleado;
